import React from 'react';

export default {
  width: 18,
  height: 14,
  content: (
    <path d="M6.966 9.227l-.282 3.909c.403 0 .577-.171.786-.376l1.886-1.782 3.909 2.829c.717.395 1.222.187 1.415-.652l2.566-11.88c.228-1.048-.383-1.457-1.081-1.2L1.085 5.78C.054 6.175.07 6.742.908 7l3.856 1.185 8.955-5.538c.422-.276.805-.123.49.153L6.966 9.227z" />
  )
};
